import { render, staticRenderFns } from "./CancelDisputeDialog.vue?vue&type=template&id=7c86639f&scoped=true&"
import script from "./CancelDisputeDialog.vue?vue&type=script&lang=ts&"
export * from "./CancelDisputeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CancelDisputeDialog.vue?vue&type=style&index=0&id=7c86639f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86639f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c86639f')) {
      api.createRecord('7c86639f', component.options)
    } else {
      api.reload('7c86639f', component.options)
    }
    module.hot.accept("./CancelDisputeDialog.vue?vue&type=template&id=7c86639f&scoped=true&", function () {
      api.rerender('7c86639f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/CancelDisputeDialog.vue"
export default component.exports